import {
    CustomServiceDefinition,
    ServiceDefinition,
    type ServiceDefinitionTemplate,
    type ServiceProvider,
} from "../api";
import { ValueObject } from "../base";

export class ServiceDefinitionTemplateValue
    extends ValueObject(
        class {
            readonly providerId?: ServiceProvider.Id;
            readonly serviceId: ServiceDefinition.Id;
            readonly shortId?: string;
            readonly serverUrl: string;
            readonly name: string;
            readonly description?: string;
            readonly actionLabel?: string;

            constructor(value: ServiceDefinitionTemplate) {
                if (CustomServiceDefinition.isCustomServiceId(value.serviceId)) {
                    const { providerId, serviceId, shortId } = CustomServiceDefinition.parse(value.serviceId);
                    this.providerId = providerId;
                    this.serviceId = serviceId;
                    this.shortId = shortId;
                } else {
                    this.serviceId = value.serviceId;
                }
                this.serverUrl = removeTrailingSlash(value.serverUrl);
                this.name = value.name;
                this.description = value.description;
                this.actionLabel = value.actionLabel;
            }
        }
    )
    implements ServiceDefinitionTemplate
{
    /**
     * Returns the provider id.
     *
     * @returns The provider id.
     */
    getProviderId(): ServiceProvider.Id | undefined {
        return this.providerId;
    }

    getConfigureUrl(): string {
        // eslint-disable-next-line max-len
        return `${this.serverUrl.endsWith("#") ? this.serverUrl : this.serverUrl + "/"}configurator?serviceId=${this.serviceId}${this.shortId ? `&shortId=${this.shortId}` : ""}`;
    }

    getEditUrl(): string {
        return `/edit?serviceId=${this.serviceId}${this.shortId ? `&shortId=${this.shortId}` : ""}`;
    }

    static getCustomizeUrl(service: ServiceDefinitionTemplate) {
        let plainServiceId: string = service.serviceId;
        if (CustomServiceDefinition.isCustomServiceId(plainServiceId)) {
            plainServiceId = CustomServiceDefinition.parse(plainServiceId).serviceId;
        }
        if (ServiceDefinition.isIndividualServiceId(plainServiceId)) {
            return `/customize/individual?serviceId=${plainServiceId}`;
        }
        return `/customize?serviceId=${plainServiceId}`;
    }

    static create(serviceDefinition: ServiceDefinitionTemplate): ServiceDefinitionTemplateValue {
        if (serviceDefinition instanceof ServiceDefinitionTemplateValue) {
            return serviceDefinition;
        }
        return new ServiceDefinitionTemplateValue(serviceDefinition);
    }
}

const removeTrailingSlash = (url: string): string => (url.endsWith("/") ? url.slice(0, -1) : url);
